export default __webpack_public_path__ + "static/media/schedule.9e0a3dec.svg";